import { Map } from 'immutable';
import { constants as performanceConstants } from '@saucelabs/sl-module-performance';

import * as constants from '../types';
import { DEFAULT_SELECTED_METRICS } from '../../../constants';
import { shouldChangeMetricSelection } from '../../../utils';

const { PERFORMANCE_TYPE } = performanceConstants;
const initialState = Map({
  orderIndex: '',
  loading: true,
  failure: null,
  selectedMetrics: DEFAULT_SELECTED_METRICS[PERFORMANCE_TYPE.HARD],
  isBaselineDataSufficient: true,
  perfType: 'hard',
  isLighthouseV6: false,
});

const commonReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.INITIALIZE.REQUEST: {
      return state.withMutations((newState) => {
        newState
          .set('orderIndex', payload)
          .set('loading', true);
      });
    }
    case constants.INITIALIZE.SUCCESS:
      return state.set('loading', false);
    case constants.INITIALIZE.FAILURE: {
      return state.withMutations((newState) => {
        newState
          .set('failure', payload)
          .set('loading', false);
      });
    }
    case constants.GET_METRICS_HISTORY.FAILURE:
    case constants.GET_JOB_DATA.FAILURE:
      return state.set('failure', payload);
    case constants.UPDATE.SELECTED_TEST_PAGE_INFO:
      return state.set('orderIndex', payload);
    case constants.UPDATE.SELECTED_METRICS:
      return state.set('selectedMetrics', payload);
    case constants.GET_METRICS_HISTORY.SUCCESS: {
      // Check if baseline data exists for first selected metrics
      // It render warning message if baseline data is not present for the first selected metrics
      const [{ name }] = state.get('selectedMetrics');
      return state.set('isBaselineDataSufficient', Object.keys(payload).includes(name) &&
        Array.isArray(payload[name]) && payload[name].length > 0);
    }
    case constants.UPDATE.PERF_TYPE: {
      return state.withMutations((newState) => {
        if (
          state.get('perfType') !== payload &&
          shouldChangeMetricSelection(payload, state.get('selectedMetrics'))
        ) {
          const defaultMetrics = DEFAULT_SELECTED_METRICS[payload] ||
            DEFAULT_SELECTED_METRICS[PERFORMANCE_TYPE.HARD];
          newState.set('selectedMetrics', defaultMetrics);
        }
        return newState.set('perfType', payload);
      });
    }
    case constants.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default commonReducer;
export { initialState };
